import * as React from 'react';
import styled from 'styled-components';
import SvgIcon from '../../../components/SvgIcon';
import { StatsBlock } from './Common';

export interface WritingStatProps {
  title: string;
  stat: string;
  change: number;
}

interface Props {
  readonly stats: ReadonlyArray<WritingStatProps>;
  readonly className?: string;
}

const BlockContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  color: ${p => p.theme.color.battleshipGrey};
  font-weight: ${p => p.theme.font.weight.normal};
  font-size: 14px;
`;

const Stat = styled.span`
  color: ${p => p.theme.color.black};
  font-weight: ${p => p.theme.font.weight.medium};
  font-size: 24px;
  margin: 8px 0;
`;

const Change = styled.span`
  color: ${p => p.theme.color.battleshipGrey};
  font-weight: ${p => p.theme.font.weight.medium};
  font-size: 12px;
  margin-left: 4px;
`;

const ChangeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ChangeBlock = ({ change }: { change: number }) => {
  const changeIcon = change > 0 ? 'ic-green-arrow-up' : 'ic-red-arrow-down';
  return (
    <ChangeContainer>
      {change > 0 && <SvgIcon iconName={changeIcon!} iconWidth={8} iconHeight={4} />}
      {change > 0 && <Change>{`${change}%`}</Change>}
    </ChangeContainer>
  );
};

const WritingStatsBlock = (props: WritingStatProps) => {
  return (
    <BlockContainer>
      <Title>{props.title}</Title>
      <Stat>{props.stat}</Stat>
      {props.change !== 0 && <ChangeBlock change={props.change} />}
    </BlockContainer>
  );
};

const StatsContainer = styled(StatsBlock)`
  display: flex;
  flex-direction: row;
  padding: 20px 95px;
  justify-content: space-between;
`;

const WritingStats = (props: Props) => {
  return (
    <StatsContainer className={props.className}>
      {props.stats.map(stat => {
        return <WritingStatsBlock title={stat.title} stat={stat.stat} change={stat.change} key={stat.title} />;
      })}
    </StatsContainer>
  );
};

export default WritingStats;



// WEBPACK FOOTER //
// ./src/containers/Stats/Components/WritingStats.tsx